import type { ExpertAssistMessage } from "../../shared-types";

import { Feedback } from "../feedback-loader";
import { QuickActionGroup, type QuickActionGroupProps } from "../quick-actions";

interface MessageActionsProps {
    shouldRenderActionsOutside: boolean;
    isQuickActionsVisible: boolean;
    quickActionGroupProps: QuickActionGroupProps;
    shouldShowFeedback: boolean;
    message?: ExpertAssistMessage;
}

export function MessageActions({
    shouldRenderActionsOutside,
    isQuickActionsVisible,
    quickActionGroupProps,
    shouldShowFeedback,
    message,
}: MessageActionsProps) {
    return (
        <>
            {isQuickActionsVisible && !shouldRenderActionsOutside && <QuickActionGroup {...quickActionGroupProps} />}
            {shouldShowFeedback && <Feedback message={message} />}
        </>
    );
}
